export default __webpack_public_path__ + "locales/lo-LA/SingleSignOn.json?hash=1b847832db2dfb5c52e932596f941c71";